module.exports = __webpack_public_path__ + "img/bg-top.d633ff73.png";